function add_autocomplete() {
  var ENDPOINT = {
    "de": '/de/vaccinationcheck/vaccinations',
    "fr": '/fr/vaccinationcheck/vaccinations',
    "it": '/it/vaccinationcheck/vaccinations'
  }

  var NoResultText = {
    "de": "Es wurde kein Ergebnis gefunden. Für eine weitere Abklärung der Rückstellungsfrist können Sie direkt mit dem Spendearzt Rücksprache halten. Für nicht zugelassene Impfstoffe gilt eine generelle Rückweisungsfrist von 12 Monaten.",
    "fr": "Aucun résultat n'a été trouvé. Pour plus d'informations sur la période d'attente, vous pouvez consulter directement le médecin du service régional de transfusion sanguine. Une période générale d'attente de 12 mois s'applique aux vaccins non approuvés.",
    "it": "Non è stato trovato alcun risultato. Per ulteriori informazioni sul periodo di attesa, potete consultare direttamente il medico del servizio trasfusionale regionale. Un periodo di attesa generale di 12 mesi si applica ai vaccini non autorizzati."
  }

  var vaccination_input = jQuery_custom('.vaccination-autocomplete');
  vaccination_input.autocomplete({
    source: function (request, response) {
      jQuery_custom.getJSON(ENDPOINT[vaccination_input.data('locale')], {
        vaccination_search: {
          term: request.term,
        }
      }, function (res) {
        response(res.map(function (val) {
          return { id: val[0], value: val[1] }
        }));
      })
    },
    minLength: 1,
    response: function(event, ui) {
      if (!ui.content.length) {
        ui.content.push({ value:"", label: NoResultText[vaccination_input.data('locale')] });
      }
    },
    select: function( event, ui ) {
      $(event.target).parents('.vaccination-group').find('input[type=hidden]').val(ui.item.id);
    }
  });
};

jQuery_custom(document).ready(function() {
  add_autocomplete()
  jQuery_custom("#add_vaccination").on("cocoon:after-insert", function() { add_autocomplete() })
});